export enum RecipientTypeEnum {
    Intern = 1,
    Principal = 2,
    Mentor = 3,
    Other = 4,
    CampusSupervisor = 5
}
